<template>
    <img class="down_arrow" src="@/assets/images/login/down_arrow.png" alt="">
</template>

<style lang="scss" scoped>
  .down_arrow{
    width: 12px;
    height: 12px;
  }
</style>